module.exports = __webpack_public_path__ + "img/smartdraw_video_tutorial_splash.3c50d5f5.jpg";